import { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { track } from '../lib/api';
import { trackPixelEvent } from '../lib/pixels';

export default function StickyMobileCta({ settings, geo }) {
  const [show, setShow] = useState(false);
  const tg = settings?.telegram_link || '#';
  const label = settings?.cta_primary_label || 'Join Telegram';

  useEffect(() => {
    function onScroll() {
      const y = window.scrollY;
      const doc = document.documentElement;
      const h = doc.scrollHeight - doc.clientHeight;
      const near = y > 300; // appear after a bit of scroll
      const atBottom = y > h - 200; // hide near final CTA / footer
      setShow(near && !atBottom);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  function handleJoin() {
    trackPixelEvent('Subscribe', { source: 'sticky' });
    track({ type: 'tg_click', country_code: geo?.country_code, country_name: geo?.country_name, source: 'sticky' });
  }

  if (!show) return null;
  return (
    <div className="md:hidden fixed left-0 right-0 bottom-0 z-40 px-3 safe-bottom">
      <a href={tg} target="_blank" rel="noreferrer" onClick={handleJoin} data-testid="sticky-join-telegram-button">
        <Button className="w-full cta-sheen border-0 text-white font-semibold h-12 text-base shadow-[0_8px_30px_rgba(225,29,46,0.35)]">{label}</Button>
      </a>
    </div>
  );
}
